import type { IOrganizationDetailsCurrency } from './OrganizationDetailsCurrency.interface';

export default class OrganizationDetailsCurrency implements IOrganizationDetailsCurrency {
  cc: string;
  name: string;
  symbol: string;

  /**
   * Constructor
   * @param {IOrganizationDetailsCurrency} data
   */
  constructor(data?: IOrganizationDetailsCurrency) {
    this.cc = data?.cc || '';
    this.name = data?.name || '';
    this.symbol = data?.symbol || '';
  }
}
